import LogoGreenSK from '@shared/svg/logo-green-sk.svg'

export const smiList = [
	{
		href: 'https://sk.ru/news/creditclub-otkryl-bankam-svobodnyj-dostup-v-lichnyj-kabinet-kreditora-dlya-bystrogo-zapuska-kreditovaniya-pod-zalog-nedvizhimosti/',
		Svg: LogoGreenSK,
		title:
			'Credit.Club открыл банкам свободный доступ в личный кабинет кредитора для быстрого запуска кредитования под залог недвижимости',
	},
	{
		href: 'https://vc.ru/tribuna/280620-platforma-cifrovyh-resheniy-credit-club-pomogaem-bankam-zapuskat-novye-produkty-i-masshtabirovat-biznes',
		imgName: 'vcru.png',
		title:
			'Платформа цифровых решений Credit.Club: помогаем банкам запускать новые продукты и масштабировать бизнес',
	},
	{
		href: 'https://expert.ru/ural/2021/29/kraudlending-nayti-balans-mezhdu-investorom-zayemschikom-i-regulyatorom/',
		imgName: 'expert.png',
		title: 'Краудлендинг: найти баланс между инвестором, заемщиком и регулятором',
	},
	{
		href: 'https://ekb.dk.ru/news/237153780',
		imgName: 'quarter.png',
		title: 'Credit.Club: технологии позволяют запускать нецелевую ипотеку в банках в один клик',
	},
	{
		href: 'https://vc.ru/tribuna/109113-investicionnaya-platforma-credit-club-bystrye-dengi-dlya-biznesa-i-investicii-s-minimalnymi-riskami',
		imgName: 'vcru.png',
		title:
			'Инвестиционная платформа Credit.Club: быстрые деньги для бизнеса и инвестиции с минимальными рисками',
	},
	{
		href: 'https://blogs.forbes.ru/2019/12/19/chto-takoe-p2p-platformy-i-kak-oni-rabotajut/',
		imgName: 'forbes.png',
		title: 'Что такое P2P-платформы и как они работают',
	},
	{
		href: 'https://vc.ru/finance/102104-zachem-biznesu-kreditovatsya-na-investicionnyh-platformah',
		imgName: 'vcru.png',
		title: 'Зачем бизнесу кредитоваться на инвестиционных платформах',
	},
	{
		href: 'https://vc.ru/finance/116260-credit-club-uskoril-vydachu-deneg-biznesu',
		imgName: 'vcru.png',
		title: 'Credit.Club ускорил выдачу денег бизнесу',
	},
	{
		href: 'https://spark.ru/startup/credit-club/blog/54178/chto-dayot-p2p-platforma-neochevidnie-bonusi-dlya-startapa',
		imgName: 'spark.png',
		title: 'Что такое P2P-платформы и как они работают',
	},
]
